export const CHANGE_LOCALE = 'I18N/CHANGE_LOCALE';
